// 사이트 공통 메뉴 표.
//
// 상단(SiteHeader · SiteHeaderMobile)과 푸터가 같은 표를 본다.
// 예전에는 상단에만 있고 푸터는 퍼블리싱 글자를 그대로 두어 이름도 링크도 어긋났다.
//
// 세 사이트가 서로 다른 도메인에 있다. 그래서 홈페이지 화면(회사소개 · B2B)도 절대 주소로 적는다 —
// 상대 주소로 두면 자사몰에서 "회사소개"를 눌렀을 때 mall.ariman.net/ 즉 자사몰 메인으로 가 버린다.
// 지금은 개발 도메인이다. 실서비스로 바꿀 때 이 파일만 고치면 된다.
//
// 전부 현재 탭에서 연다. 한 브랜드의 사이트끼리 오가는 메뉴라 새 탭으로 띄우지 않는다.
//
// ★ 이 파일은 세 저장소에 "복사"해서 쓴다.
//     homepage / goldnaramall-client / mediahub-client
//   고칠 때는 세 곳을 모두 같이 고칠 것.
export const HOME = 'https://goldnara.ariman.net'

// 차례는 2026-09-30 에 바꿨다. B2B 가 둘째에서 넷째로 내려갔다 —
// 일반 고객이 보는 것(자사몰 · 미디어 허브)을 앞에 두고 기업 대상은 뒤로 뺀다.
//   회사소개 · REAL GOLD MARKET · 미디어 허브 · B2B · REAL GOLD TRADE
// 상단과 푸터가 이 표 하나를 보므로 둘 다 같이 바뀐다.
export const SITE_MENU = [
  { key: 'about', label: '회사소개', href: `${HOME}/` },
  { key: 'market', label: 'REAL GOLD MARKET', href: 'https://mall.ariman.net' },
  { key: 'media', label: '미디어 허브', href: 'https://mediahub.ariman.net' },
  { key: 'b2b', label: 'B2B', href: `${HOME}/b2b` },
  // 지점 안내는 아직 화면이 없어 가려 둔다. 화면이 생기면 주석만 풀면 된다.
  // 아래 '지점소개'(직영점)와 겹쳐 보이는데 시안에서는 둘이 따로 있는 항목이다.
  // { key: 'branch', label: '지점 안내', href: `${HOME}/` },
  // REAL GOLD TRADE 는 **누르면 작은 메뉴가 펼쳐진다**(Figma 8236:23710).
  // 전에는 gold.ariman.net 을 임시로 걸어 두었는데, 두 화면 다 홈페이지 안으로 들어왔다.
  // children 이 있는 항목은 상단에서 <a> 가 아니라 <button> 으로 그려진다.
  // 푸터(useSiteFooter)는 label·href 만 보므로 이 표가 바뀌어도 그대로 동작한다 —
  // 푸터에서는 펼침 없이 'REAL GOLD TRADE' 한 칸이고 소개로 간다.
  {
    key: 'trade',
    label: 'REAL GOLD TRADE',
    href: `${HOME}/trade/intro`,
    children: [
      { key: 'trade-intro', label: '소개', href: `${HOME}/trade/intro` },
      { key: 'trade-rates', label: '오늘의 시세', href: `${HOME}/trade/rates` },
    ],
  },
  // 상단 메뉴 여섯 번째(마지막) 칸. 2026-10-06 에 더했고 같은 날 이름을 바꿨다 —
  // 메뉴에서는 '지점소개', 화면 안에서는 '직영점'이다(사용자 지시).
  // key 는 'agency' 그대로 둔다. 겉이름만 바뀐 것이라 주소·활성표시까지 건드릴 일이 아니다.
  { key: 'agency', label: '지점소개', href: `${HOME}/branch` },
]
